export default __webpack_public_path__ + "static/media/tudasbazis.ecace4ad.jpg";